import * as React from "react";
import { connect } from "react-redux";
import { StoreState } from "src/store";

import {
  AreaType,
  CustomerGroupFilterState,
  DashboardFilterState,
  ElectricityFilter,
  ProductType,
  SupplyType,
  Tariff,
  TernaryFilterOption,
} from "../../../types/index";
import { FilterGroup } from "../constants";
import FilterContainer from "../FilterContainer";
import CustomerTariffsFilter from "./CustomerTariffsFilter";
import {
  AreaTypeOptions,
  ContractExistingOptions,
  SupplyTypeOptions,
} from "./FilterOptions";
import ProductFamilyFilter from "./ProductFamilyFilter";

function mapStateToProps({ supplyTypesMappedToProductFamilies }: StoreState) {
  return {
    supplyTypesMappedToProductFamilies,
  };
}

type Props = {
  electricityFilter: ElectricityFilter;
  enabled: boolean;
  superordinateFilter: "CustomerGroupFilter" | "DashboardFilter";
  changeFilter: (
    payload: Partial<CustomerGroupFilterState> | Partial<DashboardFilterState>
  ) => void;
  handleEnabledChange: (filterGroup: FilterGroup, enabled: boolean) => void;
} & ReturnType<typeof mapStateToProps>;

class ElectricityFilterComponent extends React.Component<Props> {
  private changeElectricityFilter = (
    changedPartsElectricityFilter: Partial<ElectricityFilter>
  ) => {
    this.props.changeFilter({
      electricityFilter: {
        ...this.props.electricityFilter,
        ...changedPartsElectricityFilter,
      },
    });
  };

  private changeContractFilter = (filter: TernaryFilterOption) => {
    this.changeElectricityFilter({ contractExistingFilter: filter });
  };

  private changeAreaFilter = (filter: AreaType | null) => {
    this.changeElectricityFilter({ areaTypeFilter: filter });
  };

  private changeSupplyFilter = (filter: SupplyType | null) => {
    const filteredTariffs = filter
      ? this.props.electricityFilter.tariffs.filter(
          (tariff) => tariff.supplyType === filter
        )
      : this.props.electricityFilter.tariffs;
    const filteredProductFamilies = filter
      ? this.props.electricityFilter.productFamilies.filter((productFamily) =>
          this.props.supplyTypesMappedToProductFamilies.electricity[
            filter
          ].includes(productFamily)
        )
      : this.props.electricityFilter.productFamilies;
    this.changeElectricityFilter({
      supplyTypeFilter: filter,
      tariffs: filteredTariffs,
      productFamilies: filteredProductFamilies,
    });
  };

  private changeFilterEnabled = (enabled: boolean) => {
    this.props.handleEnabledChange(FilterGroup.electricity, enabled);
  };

  private changeTariffsFilter = (tariffs: Tariff[]) => {
    this.changeElectricityFilter({ tariffs });
  };

  private changeProductFamiliesFilter = (productFamilies: string[]) => {
    const filteredTariffsSelection = productFamilies.length
      ? this.props.electricityFilter.tariffs.filter((tariff) =>
          productFamilies.includes(tariff.productFamily)
        )
      : this.props.electricityFilter.tariffs;
    this.changeElectricityFilter({
      productFamilies,
      tariffs: filteredTariffsSelection,
    });
  };

  public render(): JSX.Element {
    return (
      <FilterContainer
        title="Stromverträge"
        enabled={this.props.enabled}
        onEnabledChange={this.changeFilterEnabled}
      >
        {(disabled?: boolean) => (
          <>
            <ContractExistingOptions
              contractExistingFilterState={
                this.props.electricityFilter.contractExistingFilter
              }
              onChange={this.changeContractFilter}
              disabled={disabled}
            />
            <AreaTypeOptions
              areaTypeFilterState={this.props.electricityFilter.areaTypeFilter}
              onChange={this.changeAreaFilter}
              disabled={disabled}
            />
            <SupplyTypeOptions
              supplyTypeFilterState={
                this.props.electricityFilter.supplyTypeFilter
              }
              onChange={this.changeSupplyFilter}
              disabled={disabled}
            />
            {this.props.superordinateFilter === "CustomerGroupFilter" && (
              <ProductFamilyFilter
                productTypeFilter={this.props.electricityFilter}
                onChange={this.changeProductFamiliesFilter}
                productType={ProductType.ELECTRICITY}
              />
            )}
            {this.props.superordinateFilter === "CustomerGroupFilter" && (
              <CustomerTariffsFilter
                productTypeFilter={this.props.electricityFilter}
                onChange={this.changeTariffsFilter}
                productType={ProductType.ELECTRICITY}
                disabled={disabled}
              />
            )}
          </>
        )}
      </FilterContainer>
    );
  }
}

export default connect(mapStateToProps)(ElectricityFilterComponent);



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/ElectricityFilter.tsx